import React, { useState, useEffect, useRef } from "react";
import { FormControl, Button, Form } from "react-bootstrap";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import api from "../../../api";
import { getDocumentTypeFromUrl } from "../../../utils/getDocumentTypeFromUrl";
import { getHeaderName } from "../../../utils/getHeaderName";

const SearchBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const searchRef = useRef(null);
  const navigate = useNavigate();

  const fetchResults = async (searchQuery) => {
    if (!searchQuery || searchQuery.length < 3) {
      setResults([]);
      return;
    }
    try {
      setIsFetching(true);
      const request = { resource: "api/searchmarketinghub" };
      const response = await api.searchmarketinghub.addDetails(request, { query: searchQuery });
      if (response.status === 200) {
        setResults(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setQuery(value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    fetchResults(query);
  };

  const handleResultClick = (result) => {
    setTimeout(() => {
      setIsOpen(false)
    }, 1);

    if (result.type && result.type === 'solutions') {
      navigate(`/solutions#${result.type}`, { state: { initialData: { solutionId: result?.table_id, resultType: result?.type } } })
    } else if (result.type && result.type === 'solutions_recommended_media' || result.type === 'solution_authors') {
      navigate(`/solutions#${result.type}`, { state: { initialData: { solutionId: result?.solutionsid, tableId: result?.table_id, resultType: result?.type } } })
    } else if (result.type && result.type === 'podcasts') {
      navigate(`/marketingHub#${result.type}`, { state: { initialData: { solutionId: result?.solutionsid, resultType: result?.type, tableId: result?.table_id } } })
      window.open(result?.mediaurl, "new");
    } else if (result.type && result.type === 'marketing_insights') {
      navigate(`/marketingHub#${result.type}`, { state: { initialData: { solutionId: result?.solutionsid, resultType: result?.type, tableId: result?.table_id } } })
      window.open(result?.redirecturl, "new");
    } else if (result.type && result.type !== 'solutions') {
      navigate(`/marketingHub#${result.type}`, { state: { initialData: { solutionId: result?.solutionsid, resultType: result?.type, tableId: result?.table_id } } })
    } else {
      return;
    }
  };

  const handleDownload = (fileUrl, fileName) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = `${fileName?.trim()}.${getDocumentTypeFromUrl(fileUrl)}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const groupedResults = results?.reduce((acc, result) => {
    if (!acc[result.type]) {
      acc[result.type] = [];
    }
    acc[result.type].push(result);
    return acc;
  }, {});
  

  return (<>
    <div className="position-relative pe-3">
      <Button onClick={(e) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}
        variant="outline-secondary" className='navHeader navSearchBar'>
        <FaSearch />
      </Button>
    </div>
      {isOpen && (
        <div className="position-absolute top-100 start-0 w-100 bg-white shadow p-3 rounded z-3 justify-center align-center" ref={searchRef}>
          <Form onSubmit={handleSearchSubmit} className="d-flex">
            <FormControl
              type="text"
              value={query}
              onChange={handleSearchChange}
              placeholder="Explore solutions, Collaterals, and Marketing contents across our product portfolio."
              className=""
            />
            {query && (
              <Button
                variant="light"
                className="ms-2"
                onClick={() => { setQuery("") }}
                disabled={isFetching}
              >
                <FaTimes />
              </Button>
            )}
            <Button onClick={handleSearchSubmit} variant="primary" className="ms-2" disabled={isFetching}>Search</Button>
            <Button onClick={()=>{setIsOpen(false); setResults([]); setQuery("")}} variant="primary" className="ms-2" disabled={isFetching}>Cancel</Button>
            </Form>
          <div className="pt-3">
          {isFetching ? <p className="text-muted">Fetching...</p> : (query !== '' && results?.length === 0) ? <p className="text-muted text-center">No Results Found! Please Refine your query and try again!</p> : <></>}
          </div>
          <ul className="list-group" style={{ maxHeight: '300px', overflow: 'auto' }}>
    {Object.entries(groupedResults).map(([type, items]) => (
      <React.Fragment key={type}>
        {/* Use getHeaderName function to map type to a proper header */}
        <li className="list-group-item active">{getHeaderName(type)}</li>
        
        {items.map((result) => (
          <li
            key={result.id}
            className="list-group-item list-group-item-action"
            style={{ cursor: 'pointer' }}
          >
            <div className="d-flex align-items-center">
              {result?.imageurl && (
                <img
                  src={result?.imageurl}
                  alt="preview"
                  className="me-3"
                  style={{ width: "40px", height: "40px" }}
                />
              )}
              {result.type === 'industrynews' && result?.mediaurl && (
                <img
                  src={result?.mediaurl}
                  alt="preview"
                  className="me-3"
                  style={{ width: "40px", height: "40px" }}
                />
              )}
              <div>
                {result?.title && (
                  <p className="fw-bold mb-1" onClick={() => handleResultClick(result)}>
                    {result?.title}
                  </p>
                )}
                {result?.name && (
                  <p className="fw-bold mb-1" onClick={() => handleResultClick(result)}>
                    {result?.name}
                  </p>
                )}
                {result?.employeeemail && (
                  <p className="fw-bold mb-1" onClick={() => handleResultClick(result)}>
                    {result?.employeeemail}
                  </p>
                )}
                {result?.description && (
                  <p className="text-muted small" onClick={() => handleResultClick(result)}>
                    {result?.description}
                  </p>
                )}
                {result?.downloadurl && (
                  <a
                    className="text-muted small"
                    onClick={() => {
                      handleResultClick(result);
                      handleDownload(result?.downloadurl, result?.title || result?.name);
                    }}
                  >
                    {result?.downloadurl}
                  </a>
                )}
                {result?.redirecturl && (
                  <a
                    className="text-muted small"
                    onClick={() => {
                      handleResultClick(result);
                      window.open(result?.redirecturl, "new");
                    }}
                  >
                    {result?.redirecturl}
                  </a>
                )}
                {result?.mediaurl && (
                  <p className="text-muted small" onClick={() => handleResultClick(result)}>
                    {result?.mediaurl}
                  </p>
                )}
              </div>
            </div>
          </li>
        ))}
      </React.Fragment>
    ))}
  </ul>
        </div>
      )}
    </>
  );
};

export default SearchBar;